/**
 * validate against a maximum value.
 * return original or maximum value if original is > max value
 *
 * @param {string|number} value - inserted value to compare
 * @param {string|number} maxValue - maximum value to compare against
 * @param {Function} callback - Callback for maxFunction statement
 * @returns {number} the quantity value
 */
const getMaxValue = function (value, maxValue, callback) {
  if (parseInt(value, 10) > parseInt(maxValue, 10)) {
    // Make sure the callback is a function
    if (typeof callback === "function") {
      // Execute the callback function
      callback();
    }
    return maxValue;
  }
  return value;
};

export default getMaxValue;
